module.exports = __webpack_public_path__ + "static/media/add_darkbleu.a088d453.svg";